import { type ReactElement } from 'react'
import * as S from './dream-letter.styled'
import image from './assets/image.png'
import { LinkButton } from '../button/link-button'
import { Link } from 'react-router-dom'

export function DreamLetter (): ReactElement {
  return <S.Container>
    <S.Content>
      <figure>
        <img src={image} alt="" />
        <figcaption>Imagem meramente ilustrativa</figcaption>
      </figure>
      <S.TextContainer>
        <S.TextContent>
          <h1>Você tem um sonho? A gente quer ouvir.</h1>
          <h2>Ao se filiar ao Cartão de TODOS Sonhos, você pode participar da nossa campanha mais especial: a Carta dos Sonhos.</h2>
          <p>
            Todos os filiados têm a chance de escrever uma carta contando sua história de vida e o sonho que gostariam de realizar.
            <br />
            <br />
            As cartas são apresentadas no <strong>programa Sabadão de TODOS, exibido na Band às 20h30, todo sábado.</strong>
          </p>
          <p><strong>Como funciona?</strong></p>
          <ul>
            <li>Após se tornar filiado, você acessa a plataforma exclusiva de <Link to="https://www.cartaodetodos.com.br/sonhos/carta/" rel="noopener noreferrer">envio de cartas</Link></li>
            <li>Escreva sua história com o coração</li>
            <li>E pronto: todo sábado, às 20h30, uma nova história pode ser sorteada na TV!</li>
          </ul>
        </S.TextContent>
        <LinkButton to="https://www.cartaodetodos.com.br/sonhos/carta/" rel="noopener noreferrer">Compartilhar meu sonho</LinkButton>
        <p>
          Já pensou o seu sonho sendo realizado e contado para o Brasil inteiro?
          <br />
          Com o Cartão de TODOS Sonhos, isso é possível.
        </p>
      </S.TextContainer>
    </S.Content>
  </S.Container>
}
